import { appSettings } from '@/appSettings';
import { ref } from 'vue';

export function useSatismeter(): { init: () => void, writeKey: (val: object) => void } {
    const initialized = ref(false);

    function injectScript(): void {
        window.satismeter ??= function (...args: any[]): void {
            (window.satismeter!.q = window.satismeter!.q ?? []).push(args);
        };

        window.satismeter.l = Date.now();

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://app.satismeter.com/js';

        const parent = document.getElementsByTagName('script')[0].parentNode;

        if (parent != null) {
            parent.appendChild(script);
        }
    }

    function init(): void {
        if (appSettings.enableSatismeter == null || appSettings.enableSatismeter === false) {
            return;
        }

        const key = appSettings.satismeterKey;

        if (key == null || key === '') {
            console.error('Satismeter key is not set');
            return;
        }

        if (initialized.value == null || initialized.value === false) {
            injectScript();
            initialized.value = true;
        }

        const { satismeter } = window;

        if (satismeter == null || typeof satismeter !== 'function') {
            console.error('Satismeter script not loaded or not a function');
            return;
        }

        satismeter({ writeKey: key });
    }

    function writeKey(val: object): void {
        const { satismeter } = window;

        if (satismeter == null || typeof satismeter !== 'function') {
            return;
        }

        const payload = { writeKey: appSettings.satismeterKey, ...val };
        satismeter(payload);
    }

    return {
        init,
        writeKey
    };
}
